<template>
  <no-ssr>
    <slot />
  </no-ssr>
</template>

<script>
  import NoSSR from 'vue-no-ssr';

  export default {
    name: 'NoServerRendering',
    components: {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      ['no-ssr']: NoSSR,
    },
  };
</script>
